var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modalBarang",
    attrs: {
      "id": "modal-barang",
      "title": "Tambah Barang",
      "variant": "success",
      "size": "lg",
      "hide-footer": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": ""
    }
  }, [_c('loading', {
    attrs: {
      "active": this.$store.state.barpin.isLoadingModal,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        this.$store.state.barpin.isLoadingModal = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addBarang($event)
      }
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Uraian Barang"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: _vm.errors.has('Uraian Barang') ? 'is-invalid' : '',
    attrs: {
      "type": "text",
      "name": "Uraian Barang",
      "placeholder": "..."
    },
    model: {
      value: (_vm.barang.uraian_barang),
      callback: function($$v) {
        _vm.barang.uraian_barang = $$v
      },
      expression: "barang.uraian_barang"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Uraian Barang')),
      expression: "errors.has('Uraian Barang')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Uraian Barang')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jumlah Satuan"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: _vm.errors.has('Jumlah Satuan') ? 'is-invalid' : '',
    attrs: {
      "type": "number",
      "name": "Jumlah Satuan",
      "placeholder": "..."
    },
    model: {
      value: (_vm.barang.jml_satuan),
      callback: function($$v) {
        _vm.barang.jml_satuan = $$v
      },
      expression: "barang.jml_satuan"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jumlah Satuan')),
      expression: "errors.has('Jumlah Satuan')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Jumlah Satuan')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Satuan"
    }
  }, [_c('model-list-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: _vm.errors.has('Jenis Satuan') ? 'is-invalid' : '',
    attrs: {
      "list": _vm.satuan,
      "option-value": "JNS_SAT",
      "custom-text": function (item) { return ((item.JNS_SAT) + " - " + (item.UR_SAT)); },
      "name": "Jenis Satuan",
      "placeholder": "Jenis Satuan"
    },
    model: {
      value: (_vm.barang.jns_satuan),
      callback: function($$v) {
        _vm.barang.jns_satuan = $$v
      },
      expression: "barang.jns_satuan"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jenis Satuan')),
      expression: "errors.has('Jenis Satuan')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Jenis Satuan')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jumlah Kemasan"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: _vm.errors.has('Jumlah Kemasan') ? 'is-invalid' : '',
    attrs: {
      "type": "number",
      "placeholder": "...",
      "name": "Jumlah Kemasan"
    },
    model: {
      value: (_vm.barang.jml_kemasan),
      callback: function($$v) {
        _vm.barang.jml_kemasan = $$v
      },
      expression: "barang.jml_kemasan"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jumlah Kemasan')),
      expression: "errors.has('Jumlah Kemasan')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Jumlah Kemasan')) + "\n          ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Kemasan"
    }
  }, [_c('model-list-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: _vm.errors.has('Jenis Kemasan') ? 'is-invalid' : '',
    attrs: {
      "list": _vm.kemasan,
      "option-value": "JNS_KMS",
      "custom-text": function (item) { return ((item.JNS_KMS) + " - " + (item.UR_KMS)); },
      "name": "Jenis Kemasan",
      "placeholder": "Jenis Kemasan"
    },
    model: {
      value: (_vm.barang.jns_kemasan),
      callback: function($$v) {
        _vm.barang.jns_kemasan = $$v
      },
      expression: "barang.jns_kemasan"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Jenis Kemasan')),
      expression: "errors.has('Jenis Kemasan')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Jenis Kemasan')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Bruto"
    }
  }, [_c('vue-numeric', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: _vm.errors.has('bruto') ? 'is-invalid' : '',
    attrs: {
      "currency": "Kg",
      "currency-symbol-position": "suffix",
      "separator": ".",
      "placeholder": "Bruto Barang",
      "precision": 2,
      "name": "bruto",
      "required": ""
    },
    model: {
      value: (_vm.barang.bruto),
      callback: function($$v) {
        _vm.barang.bruto = $$v
      },
      expression: "barang.bruto"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('bruto')),
      expression: "errors.has('bruto')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('bruto')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Netto"
    }
  }, [_c('vue-numeric', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "currency": "Kg",
      "currency-symbol-position": "suffix",
      "separator": ".",
      "placeholder": "Netto Barang",
      "precision": 2,
      "name": "netto",
      "required": ""
    },
    model: {
      value: (_vm.barang.netto),
      callback: function($$v) {
        _vm.barang.netto = $$v
      },
      expression: "barang.netto"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('netto')),
      expression: "errors.has('netto')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('netto')))])], 1)], 1)]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Nilai Barang (Rp)"
    }
  }, [_c('vue-numeric', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "currency": "Rp",
      "separator": ".",
      "decimal": "0",
      "name": "Nilai Barang",
      "required": ""
    },
    model: {
      value: (_vm.barang.nilai_barang),
      callback: function($$v) {
        _vm.barang.nilai_barang = $$v
      },
      expression: "barang.nilai_barang"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Nilai Barang')),
      expression: "errors.has('Nilai Barang')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Nilai Barang')))])], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "HS Code"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "8",
      "type": "text"
    },
    model: {
      value: (_vm.barang.hs_code),
      callback: function($$v) {
        _vm.barang.hs_code = $$v
      },
      expression: "barang.hs_code"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Nilai Barang')),
      expression: "errors.has('Nilai Barang')"
    }],
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Nilai Barang')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tarif Bea Masuk"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "%"
    }
  }, [_c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "minus": false,
      "precision": 1
    },
    model: {
      value: (_vm.barang.tarif_bm),
      callback: function($$v) {
        _vm.barang.tarif_bm = $$v
      },
      expression: "barang.tarif_bm"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nilai Bea Masuk"
    }
  }, [_c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "currency": "Rp",
      "separator": ".",
      "value": _vm.nilai_bm
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tarif PPN"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "%"
    }
  }, [_c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "minus": false,
      "precision": 1
    },
    model: {
      value: (_vm.barang.tarif_ppn),
      callback: function($$v) {
        _vm.barang.tarif_ppn = $$v
      },
      expression: "barang.tarif_ppn"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nilai PPN"
    }
  }, [_c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "currency": "Rp",
      "separator": ".",
      "value": _vm.nilai_ppn
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tarif PPh"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "%"
    }
  }, [_c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "minus": false,
      "precision": 1
    },
    model: {
      value: (_vm.barang.tarif_pph),
      callback: function($$v) {
        _vm.barang.tarif_pph = $$v
      },
      expression: "barang.tarif_pph"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nilai PPh"
    }
  }, [_c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "currency": "Rp",
      "separator": ".",
      "value": _vm.nilai_pph
    }
  })], 1)], 1)]), _vm._v(" "), _vm._t("default", [_c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah\n      ")])], {
    id: "footer"
  })], 2)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79d855b6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ppftz/modal/ModalBarang.vue
// module id = 356
// module chunks = 0